// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_lo-0";